import { useEffect } from "react";

/**
 * Lightweight native smooth-scroll for in-page "#" anchor links.
 * (Lenis was removed — it interfered with in-view reveal animations, forcing
 *  users to scroll before content rendered, and added scroll overhead.)
 */
export default function SmoothScroll({ children }) {
  useEffect(() => {
    const handleClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          const y = el.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);

  return children;
}
